<!-- Modal backdrop with fade animation -->
@if (modalEmptyAddressesService.isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/60 z-100 flex items-center justify-center transition-opacity duration-300 ease-in-out overflow-y-auto py-10"
    (click)="closeModal()"
    >
    <!-- Modal container with entrance animation -->
    <div
      class="bg-white rounded-lg shadow-md w-11/12 sm:w-10/12 md:w-9/12 lg:w-8/12 max-w-md mx-auto z-50 overflow-hidden transform transition-all duration-300 ease-in-out"
      (click)="$event.stopPropagation()"
      >
      <!-- Modal header -->
      <div
        class="px-4 sm:px-6 py-3 sm:py-4 border-b border-amber-300 flex justify-between items-center bg-amber-400"
        >
        <h3 class="text-base sm:text-lg font-medium text-black">
          Dirección de entrega
        </h3>
        <button
          (click)="closeModal()"
          class="text-black hover:text-gray-800 focus:outline-none transition-transform duration-300 hover:scale-110"
          >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.5"
            >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <!-- Modal body -->
        <div class="p-6 flex flex-col items-center justify-center">
          <!-- Empty state icon -->
          <div class="mb-4 text-amber-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-16 w-16"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </div>
              <!-- Empty state message -->
              <h4 class="text-lg font-medium text-gray-900 mb-2 text-center">
                No hay dirección seleccionada
              </h4>
              <p class="text-gray-600 text-center mb-6">
                Agrega una dirección para continuar con tu pedido o selecciona una.
              </p>
              <!-- Add address button -->
              <button
                (click)="openAddressModal()"
                class="w-full sm:w-auto px-6 py-3 bg-amber-500 text-white rounded-full hover:bg-amber-600 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-50 flex items-center justify-center space-x-2 transform hover:scale-105 shadow-md"
                >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 4v16m8-8H4"
                    />
                  </svg>
                  <span>Agregar dirección</span>
                </button>
              </div>
            </div>
          </div>
        }
